import Link from 'next/link';

import { SeoPopularCollection } from '@/shared/api/types';
import { Image } from '@/shared/components/image';

import styles from './CollectionItem.module.scss';
import { imageBreakpoints } from './utils';

export const CollectionItem = ({ image, name, url }: SeoPopularCollection) => {
  return (
    <Link href={url} className={styles.collectionItem} prefetch={false}>
      <Image
        className={styles.collectionItem__image}
        src={image}
        alt={name}
        title={name}
        breakpoints={imageBreakpoints}
      />
      <p className={styles.collectionItem__label}>{name}</p>
    </Link>
  );
};
